<template>
    <div class="container mb-4">
        <div class="row">
            <!-- <div class="col-12 mt-3 text-center">
                <div class="alert alert-info" role="alert">
                    Please note, all home delivery orders placed after 23rd December will be dispatched 2nd January.
                </div>
            </div> -->
            <div class="col-12 text-center">
                <h1 class="p-3 mb-0">Customer Service</h1>
                <div class="text-center mb-3">
                    <a href="/faq" class="d-inline-block py-2 px-3" title="Help Topics">Help Topics</a>
                </div>
            </div>
            <div class="col-12 col-md-8 tyreBackground p-3 p-lg-5 mt-0">
                <div class="row">
                    <NewMainMenu
                        :faqs="faqs"
                        :customer-service-email="customerServiceEmail"
                        :iconColour="iconColour"
                        :livechat="livechat"
                    ></NewMainMenu>
                </div>
            </div>
            <div class="d-none d-md-block col-12 col-sm-4 px-md-3 px-lg-5 bg-grey mt-0 align-content-center">
                <div>
                    <h2 class="fs-5">Customer service opening times</h2>
                    <p class="mb-2">Monday - Friday: 8:30am - 5:30pm</p>
                    <p class="mb-2">Saturday: Closed</p>
                    <p class="mb-2">Sunday: Closed</p>
                    <p class="mb-2">Bank Holidays: Closed</p>
                    <hr>
                    <h2 class="fs-5">How's our service?</h2>
                    <p class="mb-0">Super! We're answering queries quickly.</p>
                </div>
            </div>
        </div>
        <Transition name="fade" mode="out-in" appear>
        <div id="interactiveWrapper">
            <div v-if="showInteractive" class="row mt-3">
                <PhoneUs
                    :customer-service-number="customerServiceNumber"
                    :garage-faqs="faqs.garage"
                    :mobile-faqs="faqs.mobile"
                    :home-delivery-faqs="faqs.home_delivery"
                    :btn-active="btnActive"
                    :btn-inactive="btnInactive"
                    :accordion-bg="accordionBg"
                ></PhoneUs>
            </div>
            <div v-else-if="showContactForm" class="row mt-3">
                <div class="col-12 col-md-8 offset-md-2 text-center">
                    <h2>Ask us a question</h2>
                    <p>We will get back to you as soon as we can. Or you can email us on <a :href="'mailto:' + customerServiceEmail">{{ customerServiceEmail }}</a>.</p>
                        <ContactForm
                            :customer-service-number="customerServiceNumber"
                            :timestamp="timestamp"
                        ></ContactForm>
                </div>
            </div>
            <div v-else-if="showAddress" class="row mt-3">
                <div class="col-12 col-md-8 offset-md-2 text-center">
                    <h2>Mail Us</h2>
                    <p class="mb-0">{{ parentCompany }}</p>
                    <p class="mb-0">{{ addressOne }}</p>
                    <p class="mb-0">{{ addressTwo }}</p>
                    <p class="mb-0">{{ town }}</p>
                    <p class="mb-0">{{ county}}</p>
                    <p class="mb-0">{{ postcode }}</p>
                </div>
            </div>
        </div>
        </Transition>
    </div>
</template>

<script>
    export default {
        props: [
            'customerServiceEmail',
            'customerServiceNumber',
            'timestamp',
            'faqs',
            'parentCompany',
            'addressOne',
            'addressTwo',
            'town',
            'county',
            'postcode',
            'btnActive',
            'btnInactive',
            'accordionBg',
            'iconColour',
            'livechat'
        ],
        data() {
            return {
                showInteractive: false,
                showContactForm: false,
                showAddress: false
            }
        },
        mounted() {
			//removes loading placeholder - fixes CLS issue
			document.querySelector('#loadingPlaceholder').style.display = 'none';

            this.emitter.on('showInteractive', data => {
                this.showInteractive = true;
                this.showContactForm = false;
                this.showAddress = false;

                var element = document.getElementById("interactiveWrapper");
                element.scrollIntoView({behavior: 'smooth'});
            });

            this.emitter.on('showContactForm', data => {
                this.showContactForm = true;
                this.showInteractive = false;
                this.showAddress = false;

                var element = document.getElementById("interactiveWrapper");
                element.scrollIntoView({behavior: 'smooth'});
            });

            this.emitter.on('showAddress', data => {
                this.showAddress = true;
                this.showContactForm = false;
                this.showInteractive = false;

                var element = document.getElementById("interactiveWrapper");
                element.scrollIntoView({behavior: 'smooth'});
            });
        },
        computed: {

        }
    }
</script>

<style lang="scss" scoped>
    .tyreBackground {
        background: url('/assets/img/customerService/tyresBackground.jpg') no-repeat;
        background-size: cover;
    }
    .v-enter-active,
    .v-leave-active {
        transition: opacity 0.5s ease;
    }

    .v-enter-from,
    .v-leave-to {
        opacity: 0;
    }

</style>